import { render } from "./MasterBoardModalPagination.vue?vue&type=template&id=b49a2d0a&scoped=true"
import script from "./MasterBoardModalPagination.vue?vue&type=script&lang=js"
export * from "./MasterBoardModalPagination.vue?vue&type=script&lang=js"

import "./MasterBoardModalPagination.vue?vue&type=style&index=0&id=b49a2d0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b49a2d0a"

export default script